import Button from "@mui/material/Button";
import MuiDialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
    title: string;
    content: string;
}

export const Dialog = (props: Props) => {

    const { t } = useTranslation();
    const { title, content } = props;
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <MuiDialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle variant="h3">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{content}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} autoFocus>
                    {t("labels.cancel", "cancel")}
                </Button>
            </DialogActions>
        </MuiDialog>
    );
};
